import React from 'react';
import BgImg from '../Assets/Images/breadcrumb-bg.png'

const Breadcrumb = ({ pageTitle, breadcrumbLinks }) => {
  return (
    <div
      className="breadcrumb-area"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="breadcrumb-inner">
              <h1 className="page-title">{pageTitle}</h1>
              <ul className="page-list">
                {breadcrumbLinks.map((link, index) => (
                  <li key={index}>
                    {link.url ? <a href={link.url}>{link.label}</a> : link.label}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
